module.exports = __webpack_public_path__ + "img/cprm-logo.94e591df.jpg";